export interface EventCategoriesModel {
  objectId?: string
  updatedAt?: Date
  createdAt?: Date
  name?: string
}


export class EventCategories implements EventCategoriesModel {
  objectId?: string
  createdAt?: Date
  updatedAt?: Date
  name?: string

  constructor(
    objectId = undefined,
    createdAt = undefined,
    updatedAt = undefined,
    name = undefined
  ) {
    this.objectId = objectId
    this.createdAt = createdAt
    this.updatedAt = updatedAt
    this.name = name
  }

  static convertFromParseObject(parseObject: any): EventCategoriesModel {
    return new EventCategories(
      parseObject?.id,
      parseObject?.createdAt,
      parseObject?.updatedAt,
      parseObject?.get("name")
    )
  }
}
